import styled from 'styled-components';

const PageMask = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  background-color: rgba(0,0,0,.45);
  opacity: ${props => props.show ? '1' : '0'};
  display: ${props => props.show ? 'block' : 'none'};
  filter: alpha(opacity=45);
  -webkit-transition: opacity .3s linear,height 0s ease .3s;
  transition: opacity .3s linear,height 0s ease .3s;
  z-index: 999;
`;

export default PageMask;
